<template>
<div class="reservations-table-staffs-shift-head">
  <div class="-row">
    <div v-for="s in staffs" class="-cell" v-bind:style="cellStyleByIndex($index)">{{ s.name }}</div>
  </div>
</div>
</template>


<script>
export default {
  name: 'reservations-table-resource-staffs-shift-head',
  mixins: [require('../head.vue')],
  props: {
    staffs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    cellStyleByIndex(index) {
      return Object.assign({}, this.cellStyle, {
        'height': this.height / this.staffs.length + 'px',
        'line-height': this.height / this.staffs.length + 'px',
        'border-top-width': index === 0 ? this.borderTopWidth + 'px' : 0,
        'border-bottom-width': index === this.staffs.length - 1 ? this.borderBottomWidth + 'px' : 0,
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// head.vue?4e0f9bbf